export const ptBR = {
    values: {
        'well-operations-navigation': 'navegacao-de-operacoes-do-poco',
        'Well Operations Navigation': 'Navegação de operações do poço',
        'This plugin able to navigation in all well operations': 'Este permite navegar por todas as operações do poço'
    }
}
